import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { authProtectedRoutes } from "../../routes";
import { Loader } from "../../components/Loader";
import { Page500 } from "../../components/Utility";
import { getMe } from "../../store/actions";
import { APP_ROUTES } from "helpers/routeHelpers";

const DefaultLayout = ({ Layout }) => {
    let dispatch = useDispatch();
    const { tokenVerified, isLoading } = useSelector((state) => state.root);
    const { isAuthenticated } = useSelector((state) => state.userAuth);

    // Lowercase `type` — the API's GetMe response (spread verbatim into
    // userAuth.user by authReducer's ME_SUCCESS) uses the backend's field
    // name, not this app's own `Token`-style capitalization convention.
    // `.Type` here always read undefined, which made `Role` (and therefore
    // every permission check below) meaningless.
    const Role = useSelector((state) => state?.userAuth?.user?.type);

    useEffect(() => {
        if (isAuthenticated) {
            if (!tokenVerified) {
                dispatch(getMe()).catch(() => {});
            }
        }
    }, []);

    if (!isAuthenticated) {
        // return <Redirect to={APP_ROUTES.LOGIN} />;
        window.location.replace(APP_ROUTES.LOGIN);

    }

    // Case-insensitive on purpose: the backend's UserType enum is
    // ("USER" | "ADMIN"), all caps, while this app's own Roles constant
    // (constants/Roles.js, used for the permissions lists in routes/index.js)
    // spells the same role "Admin" for display purposes. Comparing them
    // case-sensitively — even after the `.Type`/`.type` fix above — would
    // never match, and would filter every route out for the only role that
    // exists here. Also no longer negated: keep the routes this role IS
    // permitted for, not the ones it isn't.
    const roleBasedRoutes = authProtectedRoutes.filter((item) =>
        item.permissions?.some((permission) => permission?.toUpperCase() === Role?.toUpperCase()),
    );

    return tokenVerified ? (
        <Switch>
            {roleBasedRoutes.map((route, index) => {
                return (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={(props) => (
                            <Layout>
                                <route.component {...props} />
                            </Layout>
                        )}
                    />
                ); 
            })}

            <Redirect to={APP_ROUTES.BLS_FEEDBACK} />
        </Switch>
    ) : !tokenVerified && isLoading ? (
        <Loader classes="vh-100" showVerifyText={true} />
    ) : // <Page500 />
    null;
};

export default DefaultLayout;
